<div class="mb-5">
    <h3 class="fw-bold text-capitalize mb-4">Hi {{userFirstName}}!</h3>
    <p class="text-medium-emphasis mb-2">Your current profile can only be used in our app <br><strong>SprintPass for
            drivers</strong></p>
   <app-download-logo></app-download-logo>
    <h4 class="text-primary fw-bold my-4">Are you interested in<br>SprintPass scheduling?</h4>
    <p class="text-medium-emphasis mb-2">To continue you must activate this feature.</p>
    <p class="text-medium-emphasis font-size--small">Once this process is finished you can take advantage of<br>
        <strong class="font-size--medium">SprintPass scheduling</strong> and <strong
            class="font-size--medium">SprintPass for drivers</strong>
    </p>
</div>
<div class="d-flex flex-row-reverse justify-content-center align-items-stretch">
    <a [routerLink]="['/dispatcher-profile-activation']" class="btn btn-primary">
        Activate
    </a>
    <button type="button" class="btn me-3" (click)="cancel()">
        Cancel
    </button>
</div>